export function haveDifferentKeys(a, b) {
    return a.length !== b.length || Boolean(a.find(item => !b.find(({key}) => key === item.key)));
}


// WEBPACK FOOTER //
// ./src/utils/compare.js